// import React from "react";
import { Form, InputNumber } from "antd";

const EditPasscode = () => {
  return (<>
    <Form.Item
      name={"password"}
      label={"PassCode"}
      rules={[
        {required: true, message: "Your PassCode number is required", pattern: new RegExp(/^[0-9]+$/)},
        {type: "number", min: 0, max: 9999, message: "Please enter your complete PassCode number"}
      ]}
    >
      <InputNumber placeholder="PassCode" style={{width:'100%'}} />
    </Form.Item>
  </>);
};
export default EditPasscode;
